export enum SiteTab{
    Overview = "tab-overview",
    CustomFields = "tab-custom-fields",
    Hazards = "tab-hazards",
    Contacts = "tab-contacts"
}
